import React from "react";
import { Button } from "@mui/material";
import{ Typography }from "@mui/material";
import { Link } from "react-router-dom";
import VolunteerActivismIcon from "@mui/icons-material/VolunteerActivism";
import text from '../assets/text.png';
import Slideshow from "../components/SlideShow";
import Header from "../components/Header";
import Footer from "../components/Footer";
import SamriddhiIcon from '../components/SamriddhiIcon.jpg'; 


export default function LandingPage() {
  return (
    <div>
      {/* Header */}
      <div style={{
        background: "linear-gradient(90deg, #5d9ca4 0%, #7fc7d9 100%)",
        color: "white",
        textAlign: "center",
        padding: "18px 0",
        fontSize: "2rem",
        fontWeight: 700,
        letterSpacing: "2px",
        boxShadow: "0 2px 8px rgba(93,156,164,0.12)"
      }}>
        Late Leelawati Chaturvedi Samriddhi Trust
      </div>
      <Header />

      <section style={{
        textAlign: "center",
        padding: "80px 20px 60px 20px",
        borderBottomLeftRadius: 40,
        borderBottomRightRadius: 40,
        boxShadow: "0 8px 32px rgba(93,156,164,0.08)"
      }}>
        <img
          src={SamriddhiIcon}
          alt="Samriddhi Trust Icon"
          style={{
            width: 220,
            height: 220,
            padding: 16,
            marginBottom: 24,
            borderRadius: "10%",
            boxShadow: "0 4px 24px rgba(93,156,164,0.18)",
            border: "6px solid #5d9ca4",
            background: "#fff"
          }}
        />
          <Slideshow />
        <div style={{ maxWidth: 600, margin: "0 auto 32px auto" }}>
        </div>
        <h1 style={{
          fontSize: "2.8rem",
          margin: "28px 0 24px 0",
          fontWeight: 800,
          color: "#2c3e50",
          lineHeight: 1.15,
          letterSpacing: "1px"
        }}>
          Towards Improving <br /> Quality of Life…
        </h1>
        <Button
          variant="contained"
          component={Link}
          to="/About"
          style={{
            background: "linear-gradient(90deg, #5d9ca4 0%, #7fc7d9 100%)",
            padding: "14px 38px",
            fontSize: "1.2rem",
            fontWeight: 600,
            color: "#fff",
            borderRadius: 30,
            boxShadow: "0 2px 8px rgba(93,156,164,0.18)",
            textTransform: "none"
          }}
        >
          Learn more
        </Button>
      </section>

      {/* Testimonials */}
    <section style={{ padding: "40px 20px", backgroundColor: "#5d9ca4", textAlign: "center" }}>
        <h2 style={{ color: 'white', fontWeight: "bold" }}>
            Join our community of changemakers and supporters
        </h2>
        <div style={{ display: "flex", justifyContent: "center", flexWrap: "wrap", marginTop: 30, gap: 20 }}>
            {[
            {
                quote: "Improving Quality of Life through Better Health Nutrition, Water & Sanitation and Education.",
                name: "Samriddhi Trust",
                image: SamriddhiIcon,
            },
            {
                quote: "Improving Quality of Life through enhanced Skills and Income Generation Avenues.",
                name: "Samriddhi Trust",
                image: SamriddhiIcon,
            },
            {
                quote: "Improving Quality of Life through better Education & Life Skills.",
                name: "Samriddhi Trust",
                image: SamriddhiIcon,
            },
            {
                quote: "Improving Quality of Life through Better Governance.",
                name: "Samriddhi Trust",
                image: SamriddhiIcon,
            }
            ].map((item, idx) => (
            <div key={idx} style={{
                backgroundColor: "#d7f1f6",
                padding: "20px",
                width: 200,
                heifht: 300,
                borderRadius: 10,
                textAlign: "left",
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between"
            }}>
                <div style={{ fontSize: "30px", color: "black" }}>
                   <img src={text} alt="quote" style={{ width: 50, height: 50, marginRight: 10 }} />
                </div>
                <p style={{ fontSize: "18px", fontWeight: 500, color: "black", margin: "10px 0" }}>
                {item.quote}
                </p>
                <div style={{ display: "flex", alignItems: "center", marginTop: "20px" }}>
                    <img src={item.image} alt="avatar" style={{ width: 32, height: 32, borderRadius: "50%", marginRight: 10 }} />
                    <div style={{ display: "flex", flexDirection: "column" }}>
                        <span style={{ fontWeight: "bold", fontSize: "14px", color: "black" }}>{item.name}</span>
                        <span style={{ fontSize: "12px", color: "black" }}>{item.role}</span>
                    </div>
                </div>
            </div>
            ))}
        </div>
    </section>

      <section style={{ backgroundColor: "#f0f0f0", padding: "40px 20px", textAlign: "center" }}>
          <Typography variant="h3" component="h2" align="center" sx={{ mb: 6 }}>
            Support our cause
          </Typography>        <div style={{ display: "flex", justifyContent: "center", gap: 20, marginTop: 20, flexWrap: "wrap" }}>
          <div
            style={{
              backgroundColor: "#d1ecf1",
              padding: 40,
              width: 350,
              borderRadius: 20,
              border: "3px solid #5d9ca4",
              boxSizing: "border-box",
              boxShadow: "0 4px 16px rgba(93,156,164,0.08)",
            }}
          >
            <div style={{ justifyContent: 'space-between', display: 'flex', alignItems: 'center' }}>
              <h2 style={{ fontSize: "2rem" }}>Donate now</h2>
              <VolunteerActivismIcon style={{ fontSize: 40 }} />
            </div>
            <p style={{ fontSize: "22px", lineHeight: 1.3 }}>Make a Difference</p>
            <p style={{ textAlign: 'left', fontSize: "18px" }}>
              Monthly meditation sessions for<br />
              Diverse music collection<br />
              Engage with our supportive community
            </p>
            <Button
              variant="outlined"
              component={Link}
              to="/Support"
              style={{ fontSize: "18px", padding: "10px 28px", borderColor: "#5d9ca4", color: "black" }}
            >
              Support Now
            </Button>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
}
